module.exports = __webpack_public_path__ + "static/milanka-studio-logo-wh-6df22f81c59297e5870ea159a0ececf2.png";